<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           :sumObject="sumObject"
                           :showSummary="showSummary"
                           adaptiveHeight="123"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <flowInfo v-if="showFlowInfo"
                  :formData="formData"
                  :spInfo="spInfo"
                  :flowInfo="flowInfo"
                  :loading="dialogLoading"
                  @closeDialog="closeDialog">
        </flowInfo>

        <flowView v-if="showFlowView"
                  :formData="formData"
                  :spInfo="spInfo"
                  :flowInfo="flowInfo"
                  :loading="dialogLoading"
                  @closeDialog="closeDialog">
        </flowView>
        <mxInfo v-if="showMxInfo"
                :formData="formData"
                :loading="dialogLoading"
                @closeDialog="closeDialog">
        </mxInfo>
    </div>
</template>

<script>
    import toolBar from '@/components/page/stock/checkbill/toolBar'
    import tableGrid from '@/components/tools/table'
    import mxInfo from './mxInfo'
    import {MessageBox} from "element-ui";
    import flowInfo from "@/components/flow/flowInfo"
    import flowView from "@/components/flow/flowInfo/view"

    export default {
        name: "checkbill",
        props: ['menuData'],
        components: {tableGrid, mxInfo, toolBar, flowInfo, flowView},
        data() {
            return {
                showSummary:true,
                sumObject: {},
                activeName: "first",
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData: {}
                },

                width: "350px",

                dialogLoading: false,
                showMxInfo:false,

                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {
                        column_name: "_px", column_comment: "序号", column_width: "70"
                    },
                    {
                        column_name: "reviewState", column_comment: "流程信息", column_width: "120", type: "tag",
                        info: [
                            {code: '2', name: '流程完成', type: 'success',
                                otherKey: 'cancelState',
                                otherCode: '1',
                                otherName: '已撤销',
                                otherType: 'danger'},
                            {code: '1', name: '审核中', type: 'warning'},
                            {code: '0', name: '已提交审核', type: 'info'},
                            {
                                code: '-2',
                                name: '未提交审核',
                                type: 'primary',
                                otherKey: 'cancelState',
                                otherCode: '1',
                                otherName: '已撤销',
                                otherType: 'danger'
                            }]
                    },
                    {column_name: "departmentNameBill", column_comment: "所属部门", column_width: "150"},
                    {
                        column_name: "billNo", column_comment: "盘点账单编号", column_width: "150"
                    },
                    {
                        column_name: "billDate", column_comment: "盘点日期", column_width: "120"
                    },
                    {
                        column_name: "warehouseNo", column_comment: "盘点仓库", column_width: "120"
                    },
                    {
                        column_name: "departmentName", column_comment: "盘点部门", column_width: "150"
                    },
                    {
                        column_name: "person", column_comment: "盘点人", column_width: "100"
                    },
                    {
                        column_name: "checkTotal", column_comment: "盘点小计", column_width: "150"
                    },
                    {
                        column_name: "taxTotal", column_comment: "账单合计", column_width: "150"
                    },
                    {
                        column_name: "makeBy", column_comment: "制单人", column_width: "100"
                    },
                    {
                        column_name: "makeDate", column_comment: "制单时间", column_width: "180"
                    }, {
                        column_name: "remark", column_comment: "备注", column_width: "150"
                    }
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                showFlowInfo: false,
                showFlowView: false,

                billType: "CheckBill",
                flowInfo: {},
                flowTypeList: this.$store.state.flowTypeList,
                spInfo: {},
            }
        },
        mounted() {
            this.getListData();

            this.flowInfo = {
                billType: "CheckBill",
                model_key: "KEY_CheckBill",
                billTypeCN: "盘点单",
                linkUrl: "checkbill",
            }
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/checkbill/list",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.jsonObject.data;
                    this.sumObject = data.data.sumObject;
                    this.pageInfo.total = data.data.jsonObject.count;
                }
                this.loading = false;
            },

            closeDialog() {
                this.showFlowInfo = false;
                this.showFlowView = false;
                this.showMxInfo =false;
                this.getListData();
            },
            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
                let selList = this.$refs.tableGrid.getSelList();
                if (type === "print") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }

                    let param = {
                        url: "/checkbill/print",
                        param: {
                            billId: this.formData.billId
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode === '0') {
                        let fileName=data.data.fileName;
                        window.open(window.host.ProjectUrl + "/"+fileName)
                    }else{
                        this.$message({message: data.data.infoDescribe, type: 'error'});
                        return;
                    }
                }
                if (type === "add") {
                    this.formData = {}
                    let param = {
                        url: "/checkbill/goAdd",
                        param: {}
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == "0") {
                        this.formData = data.data.varBill;
                    }
                    this.showMxInfo =true;
                }
                if (type === "edit" || type === "delete" || type === "cancel") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }
                    let params = {
                        url: "/checkbill/getBill",
                        param: {
                            billId: this.formData.billId
                        }
                    }
                    let flag = await this.$sqlOpt.flow.checkBillState(params, this.billType);
                    if (!flag)
                        return;

                    this.formData = JSON.parse(JSON.stringify(this.formData));
                    if (type === "edit") {
                        this.showMxInfo =true;
                    }
                    if (type === "delete" || type === "cancel") {
                        let param = {
                            url: "/checkbill/cancel",
                            param: {
                                billId: this.formData.billId,
                            }
                        }
                        this.$sqlOpt.cancel.cancel(param, this, this.refresh);
                    }
                }
                if (type === "subFlow") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }

                    let params = {
                        url: "/checkbill/getBill",
                        param: {
                            billId: this.formData.billId
                        }
                    }
                    let reviewAll_param = {
                        url: "/checkbill/reviewAll",
                        param: {
                            billId: this.formData.billId
                        }
                    }
                    let flag = await this.$sqlOpt.flow.checkFlow(params, this.flowInfo.model_key, reviewAll_param, this);
                    if (!flag)
                        return;

                    //判断账单制单人、是否撤销、是否提交审核
                    MessageBox.confirm('确定要提交审核吗?', '提交审核提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        let startReview_param = {
                            url: "/commbill/startReview",
                            param: {
                                billId: this.formData.billId,
                                billType: this.flowInfo.billType,
                                model_key: this.flowInfo.model_key,
                            }
                        }
                        const startReview_data = await this.$store.dispatch('pubMethod', startReview_param)
                        if (startReview_data.infoCode == "0") {
                            let info = startReview_data.data.pd;
                            let goReview_param = {
                                url: "/checkbill/goReview",
                                param: {
                                    PROC_INST_ID_: info.PROC_INST_ID_,
                                    ID_: info.ID_,
                                    model_key: info.model_key,
                                    FILENAME: info.DGRM_RESOURCE_NAME_,
                                }
                            }
                            const goReview_data = await this.$store.dispatch('pubMethod', goReview_param)
                            this.spInfo = goReview_data.data;
                            this.showFlowInfo = true;
                        }
                    }).catch(() => {
                    })
                }
                if (type === "view") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }

                    let param = {
                        url: "/checkbill/view",
                        param: {
                            billId: this.formData.billId,
                        }
                    }
                    this.formData = {};
                    const data = await this.$store.dispatch('pubMethod', param)
                    this.spInfo = data.data;
                    this.showFlowView = true;
                }
            },
            refresh() {
                this.getListData();
            },
            tableOpt() {
            },
        }
    }
</script>

<style scoped lang="scss">

    ::v-deep .el-tabs__header {
        margin: 0px;
    }

    ::v-deep .el-tabs--border-card > .el-tabs__content {
        padding: 10px;
    }

    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
